// src/services/matchService.js
import { configuredAxios as api } from './axiosConfig'; // ajuste o caminho conforme necessário

const matchService = {
  // ==================================================================
  // FUNÇÕES EXISTENTES (NÃO ALTERADAS)
  // ==================================================================

  getAll: (params = {}) => api.get('/matches', { params }),

  getById: (id) => api.get(`/matches/${id}`).then(res => res.data),

  create: (data) => api.post('/matches', data),

  update: (id, data) => api.put(`/matches/${id}`, data),

  delete: (id) => api.delete(`/matches/${id}`),

  updateResult: (id, data) => api.put(`/matches/${id}/result`, data),

  monitorMatches: async () => {
    try {
      const response = await api.get('/matches');
      const matches = response.data;

      matches.forEach((match, index) => {
        console.log(`🔢 Partida ${index + 1}/${matches.length}`);
        console.log(`🆔 ID: ${match._id}`);
        console.log(`📅 Data: ${new Date(match.date).toLocaleString()}`);
        console.log(`🏟️ Local: ${match.location || '—'}`);
        console.log(`🆚 ${match.teamA?.name || 'N/A'} vs ${match.teamB?.name || 'N/A'}`);
        console.log(`⚽ Placar: ${match.scoreA ?? 0} x ${match.scoreB ?? 0}`);
        console.log(`📌 Status: ${match.status?.toUpperCase() || 'PENDENTE'}`);
        console.log(`🏆 Campeonato: ${match.championship?.name || '—'} (${match.championship?.location || '—'})`);
        console.log(`📌 Fase: ${match.phase?.toUpperCase().replace(/_/g, ' ') || '—'}${match.group ? ` | Grupo ${match.group}` : ''}`);
        console.log('-------------------------------');
      });

      return matches;
    } catch (error) {
      console.error('Erro ao monitorar partidas:', error);
      throw error;
    }
  },

  // ==================================================================
  // ✅ NOVAS FUNÇÕES ADICIONADAS (SINCRONIZADAS COM O MOBILE)
  // ==================================================================

  /**
   * Busca partidas de um campeonato específico
   * @param {string} championshipId - ID do campeonato
   * @param {Object} filters - Filtros opcionais
   * @returns {Promise<Array>} Lista de partidas do campeonato
   */
  getByChampionship: (championshipId, filters = {}) => {
    return api.get(`/championships/${championshipId}/matches`, { params: filters })
      .then(res => res.data)
      .catch(error => {
        console.error(`Erro ao buscar partidas do campeonato ${championshipId}:`, error);
        throw error;
      });
  },

  /**
   * Busca partidas de um time específico
   * @param {string} teamId - ID do time
   * @returns {Promise<Array>} Lista de partidas do time
   */
  getByTeam: (teamId) => {
    return api.get(`/teams/${teamId}/matches`)
      .then(res => res.data)
      .catch(error => {
        console.error(`Erro ao buscar partidas do time ${teamId}:`, error);
        throw error;
      });
  },

  /**
   * Busca próximas partidas
   * @param {number} limit - Limite de resultados (padrão: 10)
   * @returns {Promise<Array>} Lista de próximas partidas
   */
  getUpcomingMatches: (limit = 10) => {
    return api.get('/matches/upcoming', { params: { limit } })
      .then(res => res.data)
      .catch(error => {
        console.error('Erro ao buscar próximas partidas:', error);
        throw error;
      });
  },

  /**
   * Busca partidas recentes finalizadas
   * @param {number} limit - Limite de resultados (padrão: 10)
   * @returns {Promise<Array>} Lista de partidas recentes
   */
  getRecentMatches: (limit = 10) => {
    return api.get('/matches/recent', { params: { limit } })
      .then(res => res.data)
      .catch(error => {
        console.error('Erro ao buscar partidas recentes:', error);
        throw error;
      });
  },

  /**
   * Busca estatísticas de uma partida
   * @param {string} matchId - ID da partida
   * @returns {Promise<Object>} Estatísticas da partida
   */
  getMatchStats: (matchId) => {
    return api.get(`/matches/${matchId}/stats`)
      .then(res => res.data)
      .catch(error => {
        console.error(`Erro ao buscar estatísticas da partida ${matchId}:`, error);
        throw error;
      });
  },

  /**
   * Busca linha do tempo da partida (gols, cartões, substituições)
   * @param {string} matchId - ID da partida
   * @returns {Promise<Array>} Eventos da linha do tempo
   */
  getMatchTimeline: (matchId) => {
    return api.get(`/matches/${matchId}/timeline`)
      .then(res => res.data)
      .catch(error => {
        console.error(`Erro ao buscar linha do tempo da partida ${matchId}:`, error);
        throw error;
      });
  },

  /**
   * Busca partidas por data específica
   * @param {string} date - Data no formato YYYY-MM-DD
   * @returns {Promise<Array>} Lista de partidas da data
   */
  getMatchesByDate: (date) => {
    return api.get('/matches/by-date', { params: { date } })
      .then(res => res.data)
      .catch(error => {
        console.error(`Erro ao buscar partidas da data ${date}:`, error);
        throw error;
      });
  },

  /**
   * Deleta todas as partidas de um campeonato específico
   * @param {string} championshipId - ID do campeonato
   * @returns {Promise<Object>} Resposta da API
   */
  deleteAllMatches: (championshipId) => {
    return api.delete(`/matches/championship/${championshipId}`)
      .then(res => res.data)
      .catch(error => {
        console.error('Erro ao deletar todas as partidas:', error);
        throw error;
      });
  }
};

export default matchService;